import React, { useState, useEffect } from 'react'
import AdminLayout from '../AdminLayout'
import ContentHeader from '../layout/ContentHeader'
import { CREDIT_NOTES } from '../../../data/url';
import FormLayout from '../layout/FormLayout';
import TableLayout from '../layout/TableLayout';
import httpClient from '../../../http/HttpRequest';

export default function CreditNotes() {
     const [list, setOrderList] = useState([]);

     const tableHeaders = ['#', 'date', 'doc_no', 'customer', 'tax', 'amount', 'balance', 'action'];

     const keys = ["date", "number", "full_name", "total_tax_amount", "net_amount", 'pending_amount', "btnEdit"];

     const btnData = {
          btnEdit: {
               name: "View", link: "/root/credit-note/view"
          }
     }

     useEffect(() => {
          getCreditNotes();
     }, []);

     const getCreditNotes = async (payload = {}) => {
          const res = await httpClient.post(CREDIT_NOTES, payload);
          if (res.requestStatus == "OK") {
               const result = res.result;
               if (result.status == 1) {
                    setOrderList(result.data);
               }
          }
     }

     const [formData, setFormData] = useState({
          formTitle: 'Search Customer',
          formFields: [
               { label: 'from_date', id: 'from_date', type: 'date', name: 'from_date', value: '', className: "col-md-2" },
               { label: 'to_date', id: 'to_date', type: 'date', name: 'to_date', value: '', className: "col-md-2" },
               { label: 'customer', id: 'customer', type: 'text', name: 'name', value: '', className: "col-md-3", placeholder: 'Enter name' },
               { label: 'number', id: 'number', type: 'text', name: 'number', value: '', className: "col-md-3", placeholder: 'Enter number' },
          ],
          formErrors: { from_date: '', to_date: '', name: '', number: '' },
     });

     const handleFieldChange = (fieldName, value) => {
          setFormData((prevFormData) => {
               const updatedFormFields = prevFormData.formFields.map((field) =>
                    field.name === fieldName ? { ...field, value: value } : field
               );
               return {
                    ...prevFormData,
                    formFields: updatedFormFields,
               };
          });
     }

     const handleFieldBlur = () => { }

     const handleSubmit = (e) => {
          e.preventDefault();
          let post = {};
          const updatedFormFields = formData.formFields.map((field) => {
               post[field.name] = field.value;
               return field;
          });
          setFormData((prevFormData) => ({
               ...prevFormData,
               formFields: updatedFormFields,
          }));
          getCreditNotes(post);
     }
     return (
          <AdminLayout>
               <div className="content-wrapper">
                    <ContentHeader title="credit_notes" newButton="new" newButtonLink="root/credit-note/new" />
                    <div className="col-lg-12 grid-margin stretch-card">
                         <div className="card">
                              <div className="card-body">
                                   <FormLayout
                                        formTitle={formData.formTitle}
                                        formFields={formData.formFields}
                                        formErrors={formData.formErrors}
                                        onFieldChange={handleFieldChange}
                                        onFieldBlur={handleFieldBlur}
                                        onSubmit={handleSubmit}
                                        isModal
                                        search
                                   />
                                   <TableLayout
                                        headers={tableHeaders}
                                        keys={keys}
                                        tableData={list}
                                        id="id"
                                        btnData={btnData}
                                        numberKey={["net_amount", "total_tax_amount", "pending_amount"]}
                                   />
                              </div>
                         </div>
                    </div>
               </div>
          </AdminLayout>
     )
}
